import MagicOfMemoryFoam from "../../components/pages/blog/the-magic-of-memory-foam";

export default MagicOfMemoryFoam;
